import * as React from "react";
import { Tooltip } from "react-bootstrap";
import I18n, { PrefixedKeys } from "lib/I18n";

function createTooltip(
  messageKey: PrefixedKeys<"event_master_editor.messages.">,
) {
  return (
    <Tooltip id={`tooltip_${messageKey}`}>
      {I18n.t(`event_master_editor.messages.${messageKey}`)}
    </Tooltip>
  );
}

const tooltips = {
  s3_stats: createTooltip("s3_stats"),
  copy_from_s3: createTooltip("copy_from_s3"),
  delete_from_s3: createTooltip("delete_from_s3"),
  time_from: createTooltip("time_from"),
  time_to: createTooltip("time_to"),
  time_zone: createTooltip("time_zone"),
  save_before_deploy: createTooltip("save_before_deploy"),
};

export default tooltips;
